import React, { useState, useEffect } from "react";
import { Nav } from "../../components/nav";
import { useAuth } from "../../navigation/AuthProvider";
import "../css/Subscription.css";

import axios from "axios";
import { BACKEND_URL } from "../../constants";

export const Subscription = () => {
  const auth = useAuth();
  const company = auth?.company;
  const setCompany = auth?.setCompany;

  

  // ========== DATA FROM BACKEND (no dummy) ==========
  const currentPlan = company?.plan || null;
  const currentBillingType = company?.billingType || null;
  const currentNextBilling = company?.nextBillingDate ? new Date(company.nextBillingDate) : null;
  const currentPaidEmployees = company?.employeesAllowed || 0;

  // ========== TRIAL (completely separate) ==========
  const isTrialActive = company?.trial?.isTrial === true ||
    (company?.trial?.trialEndsAt && new Date(company.trial.trialEndsAt) > new Date());
  const trialEndsAt = company?.trial?.trialEndsAt ? new Date(company.trial.trialEndsAt) : null;
  const trialDaysLeft = trialEndsAt ? Math.ceil((trialEndsAt - new Date()) / (1000 * 60 * 60 * 24)) : 0;

  const hasActiveSubscription =
  company?.billingType === "card" &&
  company?.subscriptionStatus === "active";

  // ========== STATE ==========
  const getInitialEmployees = () => {
    return company?.employeesAllowed || 5;
  };

  useEffect(() => {
    setEmployees(company?.employeesAllowed || 5);
  }, [company?.employeesAllowed]);

  const [employees, setEmployees] = useState(getInitialEmployees());

  const isUpgrade = employees > currentPaidEmployees;


  const [billingType, setBillingType] = useState(currentBillingType || "card");
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);

  useEffect(() => {
    if (!company) return;

    const isActive =
      company.billingType === "card" &&
      company.subscriptionStatus === "active";

    setBillingType(isActive ? company.billingType : "card");

  }, [company]);


  useEffect(() => {
    const sync = async () => {
      if (!company?._id) return;

      try {
        const res = await axios.post(`${BACKEND_URL}/sync-subscription`, {
          companyId: company._id,
        });

        setCompany(res.data.company);

      } catch (err) {
        console.error("sync failed", err);
      }
    };

    sync();
  }, []);

  // Original values for comparison
  const [originalEmployees, setOriginalEmployees] = useState(getInitialEmployees());
  const [originalBillingType, setOriginalBillingType] = useState(currentBillingType || "card");

  const [isSaving, setIsSaving] = useState(false);

  const [isEditingSubscription, setIsEditingSubscription] = useState(false);



  const [showSwitchToInvoiceModal, setShowSwitchToInvoiceModal] = useState(false);
  const [invoiceEmployees, setInvoiceEmployees] = useState(company?.employeesAllowed || 5);
  const [invoiceError, setInvoiceError] = useState(null);


  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [showReactivateConfirm, setShowReactivateConfirm] = useState(false);

  // Non-linear slider mapping
  // inputValue (0-100) -> employees
  const mapSliderToEmployees = (sliderVal) => {
    if (sliderVal <= 50) {
      // 0-50 maps to 5-100
      return Math.round(5 + (sliderVal / 50) * (100 - 5));
    } else {
      // 51-100 maps to 101-500
      return Math.round(101 + ((sliderVal - 50) / 50) * (500 - 101));
    }
  };
  // employees -> slider value (inverse)
  const mapEmployeesToSlider = (emp) => {
    if (emp <= 100) {
      return ((emp - 5) / (100 - 5)) * 50;
    } else {
      return 50 + ((emp - 101) / (500 - 101)) * 50;
    }
  };

  const [sliderValue, setSliderValue] = useState(mapEmployeesToSlider(employees));

  // Sync slider when employees changes via manual input
  useEffect(() => {
    setSliderValue(mapEmployeesToSlider(employees));
  }, [employees]);

  // ========== PRICING ==========
  const calculatePrice = (empCount) => {
    const pricePerUser = 89;

    const total = empCount * pricePerUser;

    return {
      total,
      formula: `${empCount} × ${pricePerUser} = ${total} SEK`,
    };
  };

  const priceDetails = calculatePrice(employees);
  const originalPriceDetails = calculatePrice(originalEmployees);

  const getPlanName = () => {
    if (!hasActiveSubscription) return "Ingen";
    return `${company?.employeesAllowed || 0} anställda`;
  };

  // ========== HANDLERS ==========

  const handleSliderChange = (e) => {
    const val = parseInt(e.target.value, 10);
    setSliderValue(val);
    const newEmp = mapSliderToEmployees(val);
    setEmployees(newEmp);
  };

  const handleManualInput = (e) => {
    let val = parseInt(e.target.value, 10);
    if (isNaN(val)) val = 5;
    val = Math.min(500, Math.max(5, val));
    setEmployees(val);
  };



  const handleCancelSubscription = async () => {
    if (isSaving) return;
    setIsSaving(true);

    try {
      const res = await axios.post(`${BACKEND_URL}/cancel-subscription`, {
        companyId: company?._id,
      });

      alert(res.data.message);

      setCompany(res.data.company)

    } catch (err) {
      console.error(err);
      alert("Något gick fel");
    }

    setIsSaving(false);
  };


  const handleReactivateSubscription = async () => {
    if (isSaving) return;
    setIsSaving(true);

    try {
      const res = await axios.post(`${BACKEND_URL}/reactivate-subscription`, {
        companyId: company?._id,
      });

      alert(res.data.message);

      setCompany(res.data.company);

    } catch (err) {
      console.error(err);
      alert("Något gick fel");
    }

    setIsSaving(false);
  };


  const handleConfirmUpgrade = async () => {
    if (isSaving) return;
    setIsSaving(true);

    try {
      const res = await axios.post(
        `${BACKEND_URL}/update-subscription`,
        {
          employees,
          companyId: company?._id,
        }
      );

      alert(res.data.message);

      setCompany(res.data.company);

      setShowConfirmModal(false);
      setIsEditingSubscription(false);
      setOriginalEmployees(employees);

    } catch (err) {
      console.error(err);
      alert("Något gick fel");
    }

    setIsSaving(false);
  };


  const handleSave = async () => {
    if (hasActiveSubscription && !isEditingSubscription) return;
    if (isSaving) return;

    try {
      // =========================
      // 1. HAR SUBSCRIPTION
      // =========================
      if (hasActiveSubscription) {

        if (billingType === "invoice") {
          setShowSwitchToInvoiceModal(true);
          return;
        }


        setShowConfirmModal(true);
        return;
      }

      // =========================
      // 2. NY USER
      // =========================
      if (billingType === "invoice") {
        setShowSwitchToInvoiceModal(true);
        return;
      }

      const res = await axios.post(
        `${BACKEND_URL}/create-checkout-session`,
        {
          employees,
          companyId: company?._id,
        }
      );

      window.location.href = res.data.url;

    } catch (err) {
      console.error(err);
      alert("Något gick fel");
    }
  };


  const handleConfirmSwitchToInvoice = async () => {
    if (invoiceEmployees < currentPaidEmployees) {
      setInvoiceError(
        `Du kan inte välja färre än ${currentPaidEmployees} anställda`
      );
      return;
    }

    if (isSaving) return;
    setIsSaving(true);

    try {
      await axios.post(`${BACKEND_URL}/switch-to-invoice`, {
        companyId: company?._id,
        employees: invoiceEmployees,
      });

      // 👉 bättre än alert i production, men OK för nu
      alert("Fakturering aktiverad");

      setShowSwitchToInvoiceModal(false);

      // 🔥 viktig sync
      await auth.fetchCompany?.();
      setIsSaving(false);
      // alternativ: await auth.fetchCompany();

    } catch (err) {
      console.error(err);
      setInvoiceError("Något gick fel, försök igen");
      setIsSaving(false);
    }
  };

  const performSave = () => {
    console.log("Saving subscription:", { employees, billingType });
    alert(`Prenumeration uppdaterad! Ny månadskostnad: ${priceDetails.total} SEK`);

    setOriginalEmployees(employees);
    setOriginalBillingType(billingType);
    setShowInvoiceModal(false);
    setIsEditingSubscription(false);
  };

  const cancelSave = () => {
    setShowInvoiceModal(false);
  };


  const hasChanges =
  employees !== originalEmployees ||
  billingType !== originalBillingType;




  if (company?.billingType === "invoice") {
    return (
      <div className="subscription-page">
        <Nav />

        <div style={{
          maxWidth: 500,
          margin: "80px auto",
          background: "#fff",
          padding: 30,
          borderRadius: 12,
          boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
          textAlign: "center"
        }}>
          <h2 style={{ marginBottom: 10 }}>📄 Fakturering aktiv</h2>

          <p style={{ color: "#6b7280", fontSize: "0.95rem" }}>
            Ditt företag använder fakturering som betalningsmetod.
          </p>

          <p style={{ marginTop: 10, fontSize: "0.9rem" }}>
            För frågor eller om du vill göra ändringar i din prenumeration,
            vänligen kontakta oss.
          </p>

          <div style={{
            marginTop: 15,
            padding: 12,
            background: "#f3f4f6",
            borderRadius: 8,
            fontSize: "0.9rem",
            fontWeight: "500"
          }}>
            📧 company@timesmart.se
          </div>

          <a
            href="mailto:company@timesmart.se?subject=Fakturering%20TimeSmart"
            style={{
              display: "inline-block",
              marginTop: 20,
              padding: "10px 16px",
              background: "#007aff",
              color: "#fff",
              borderRadius: 8,
              textDecoration: "none",
              fontWeight: "600"
            }}
          >
            Kontakta oss
          </a>
        </div>
      </div>
    );
  }


  return (
    <div className="subscription-page">
      <Nav />
      <div className="subscription-content">

        {/* Trial banner */}
        {isTrialActive && trialDaysLeft > 0 && (
          <div className="trial-banner">
            <span className="trial-icon">🔬</span>
            <span>Testperiod aktiv — {trialDaysLeft} dagar återstår</span>
          </div>
        )}

        {/* Current subscription card */}
        <div className="current-card">
          <h2>Nuvarande prenumeration</h2>
          <div className="current-grid">
            <div className="current-item">
              <span className="current-label">Plan</span>
              <p className="current-value">{getPlanName()}</p>
            </div>
            <div className="current-item">
              <span className="current-label">Betalningsmetod</span>
              <p className="current-value">
                {currentBillingType === "invoice" ? "Faktura" : currentBillingType === "card" ? "Kort" : "–"}
              </p>
            </div>
            <div className="current-item">
              <span className="current-label">
                {company?.subscriptionEnd ? "Avslutas" : "Nästa debitering"}
              </span>

              <p className="current-value">
                {company?.subscriptionEnd
                  ? new Date(company.subscriptionEnd).toLocaleDateString("sv-SE")
                  : currentNextBilling
                  ? currentNextBilling.toLocaleDateString("sv-SE")
                  : "–"}
              </p>
            </div>
            <div className="current-item">
              <span className="current-label">Betalda anställda</span>
              <p className="current-value">
               {hasActiveSubscription ? `${currentPaidEmployees} st` : "–"}
              </p>
            </div>
            <div className="current-item">
              <span className="current-label">Status</span>
              <p className="current-value">
              {company?.subscriptionStatus === "active"
                ? "Aktiv"
                : company?.subscriptionStatus === "past_due"
                ? "Förfallen"
                : "Ingen aktiv"}
            </p>
            </div>
          </div>
        </div>

        {hasActiveSubscription && currentBillingType === "card" && (
          <div className="subscription-actions-under">
            <button
              className="action-btn"
              onClick={() => {
                if (isEditingSubscription) {
                  // reset changes
                  setEmployees(originalEmployees);
                  setBillingType(originalBillingType);
                  setIsEditingSubscription(false);
                } else {
                  // enter edit mode
                  setOriginalEmployees(employees);
                  setOriginalBillingType(billingType);
                  setIsEditingSubscription(true);
                }
              }}
            >
              {isEditingSubscription ? "❌ Avbryt redigering" : "✏️ Redigera prenumeration"}
            </button>

            {company?.subscriptionEnd ? (
              <button
                className="action-btn secondary"
                disabled={isSaving || isEditingSubscription}
                onClick={() => setShowReactivateConfirm(true)}
              >
                ↩️ Återaktivera prenumeration
              </button>
            ) : (
              <button
                className="action-btn secondary"
                disabled={isSaving || isEditingSubscription}
                onClick={() => setShowCancelConfirm(true)}
              >
                ❌ Avsluta prenumeration
              </button>
            )}

            <button
              className="action-btn secondary"
              disabled={isSaving || isEditingSubscription}
              onClick={() => {
                setShowSwitchToInvoiceModal(true);
              }}
            >
              📄 Ändra till faktura
            </button>
          </div>
        )}

        {/* Change subscription card */}
        <div className="change-card">
          <h2 className="change-title">
            {isEditingSubscription ? "Redigerar abonnemang" : "Abonnemangsinställningar"}
          </h2>
          <p className="change-subtitle">Justera antal anställda och betalningsmetod</p>

          {/* Employee selector with slider + manual input */}
          {(!hasActiveSubscription || isEditingSubscription) && (
          <div className="employee-selector">
            <div className="slider-header">
                <span>Antal anställda</span>

                <div className="employee-input-wrapper">
                    <input
                    type="number"
                    value={employees}
                    onChange={handleManualInput}
                    className="employee-input"
                    />
                    <span className="employee-suffix">st</span>
                </div>
            </div>
            <div className="slider-wrapper">
              <input
                type="range"
                min="0"
                max="100"
                step="1"
                value={sliderValue}
                onChange={handleSliderChange}
                className="employee-slider"
              />
             
            </div>
            <div className="slider-labels">
              <span>5</span>
              <span style={{marginLeft: 25}}>100</span>
              <span>500+</span>
            </div>
          </div>
          )}

          {/* Price display */}
          <div className="price-card">
            <div className="price-amount">{priceDetails.total} SEK</div>
            <div className="price-period">per månad</div>
            <div className="price-formula">{priceDetails.formula}</div>
            <div className="price-note">
              89 SEK per användare och månad
            </div>
          </div>

          {/* Billing method - simple radio/buttons, no modal on click */}
          {!hasActiveSubscription && (
            <div className="billing-group">
              <button
                className={`billing-btn ${billingType === "card" ? "active" : ""}`}
                onClick={() => setBillingType("card")}
              >
                💳 Kortbetalning
              </button>
              <button
                className={`billing-btn ${billingType === "invoice" ? "active" : ""}`}
                onClick={() => {
                  setShowSwitchToInvoiceModal(true);
                }}
              >
                📄 Faktura
              </button>
            </div>
          )}

          {/* Confirm button UNDER slider */}
          {(isEditingSubscription || !hasActiveSubscription) && (
            <button
              className="action-btn confirm"
              onClick={handleSave}
              disabled={isSaving || !hasChanges}
            >
              {hasActiveSubscription ? "✅ Bekräfta ändringar" : "🚀 Starta prenumeration"}
            </button>
          )}
        </div>
      </div>

      {showSwitchToInvoiceModal && (
        <div className="modal-overlay">
          <div className="modal-container">

            <h3>Fakturering</h3>

            <p style={{ marginTop: 10 }}>
              Vill du betala via faktura?
            </p>

            <p style={{ marginTop: 10, fontSize: "0.9rem", color: "#6b7280" }}>
              Kontakta oss så sätter vi upp fakturering och skickar en offert baserat på ert företag.
            </p>

            <div style={{
              marginTop: 15,
              padding: 12,
              background: "#f3f4f6",
              borderRadius: 8,
              fontSize: "0.9rem"
            }}>
              📧 company@timesmart.se
            </div>

            <p style={{ marginTop: 10, fontSize: "0.85rem", color: "#9ca3af" }}>
              Vi svarar vanligtvis inom 24 timmar
            </p>

            <div className="modal-buttons">
              <button
                className="modal-btn cancel"
                onClick={() => setShowSwitchToInvoiceModal(false)}
              >
                Stäng
              </button>

              <a
                href="mailto:support@timesmart.se?subject=Fakturering%20TimeSmart"
                className="modal-btn confirm"
                style={{ textDecoration: "none", display: "inline-block", textAlign: "center" }}
              >
                Kontakta oss
              </a>
            </div>

          </div>
        </div>
      )}



          {showConfirmModal && (
            <div className="modal-overlay">
              <div className="modal-container">

                <h3>Bekräfta ändring</h3>

                  {isUpgrade ? (
                    <>
                      <p>
                        Du uppgraderar från <strong>{currentPaidEmployees}</strong> till{" "}
                        <strong>{employees}</strong> användare.
                      </p>

                      <p style={{ marginTop: 12, fontWeight: 500 }}>
                        💳 Mellanskillnaden debiteras direkt.
                      </p>

                      <p style={{ marginTop: 6, fontSize: "0.85rem", color: "#6b7280" }}>
                        Den nya månadsavgiften gäller från nästa faktureringsperiod.
                      </p>

                      <div style={{ marginTop: 12 }}>
                        <strong>Ny månadsavgift:</strong> {priceDetails.total} SEK
                      </div>
                    </>
                  ) : (
                  <>
                    <p>
                      Du nedgraderar från <strong>{currentPaidEmployees}</strong> till{" "}
                      <strong>{employees}</strong> användare.
                    </p>

                    <p style={{ marginTop: 10 }}>
                      Ingen debitering sker nu.
                    </p>

                    <p style={{ marginTop: 6 }}>
                      Ny månadsavgift från nästa period:{" "}
                      <strong>{priceDetails.total} SEK</strong>
                    </p>
                  </>
                )}

                <div className="modal-buttons">
                  <button
                    className="modal-btn cancel"
                    onClick={() => setShowConfirmModal(false)}
                  >
                    Avbryt
                  </button>

                  <button
                    className="modal-btn confirm"
                    onClick={handleConfirmUpgrade}
                  >
                    Bekräfta
                  </button>
                </div>

              </div>
            </div>
          )}


          {showCancelConfirm && (
              <div className="modal-overlay">
                <div className="modal-container">

                  <h3>Avsluta prenumeration</h3>

                  <p>
                    Prenumerationen kommer att avslutas vid periodens slut.
                  </p>

                  {company?.subscriptionEnd && (
                    <p style={{ marginTop: 6 }}>
                      Aktiv till:{" "}
                      <strong>
                        {new Date(company.subscriptionEnd).toLocaleDateString("sv-SE")}
                      </strong>
                    </p>
                  )}

                  <p style={{ marginTop: 10, fontSize: "0.85rem", color: "#6b7280" }}>
                    Ingen ytterligare debitering sker efter detta datum.
                  </p>

                  <div className="modal-buttons">
                    <button
                      className="modal-btn cancel"
                      onClick={() => setShowCancelConfirm(false)}
                    >
                      Avbryt
                    </button>

                    <button
                      className="modal-btn confirm"
                      onClick={async () => {
                        await handleCancelSubscription();
                        setShowCancelConfirm(false);
                      }}
                    >
                      Bekräfta avslut
                    </button>
                  </div>

                </div>
              </div>
            )}



            {showReactivateConfirm && (
                <div className="modal-overlay">
                  <div className="modal-container">

                    <h3>Återaktivera prenumeration</h3>

                    <p>
                      Prenumerationen fortsätter som vanligt och kommer inte att avslutas.
                    </p>

                    {company?.subscriptionEnd && (
                      <p style={{ marginTop: 6 }}>
                        Planerat avslut:{" "}
                        <strong>
                          {new Date(company.subscriptionEnd).toLocaleDateString("sv-SE")}
                        </strong>
                      </p>
                    )}

                    <p style={{ marginTop: 10, fontSize: "0.85rem", color: "#6b7280" }}>
                      Debitering fortsätter enligt din nuvarande plan.
                    </p>

                    <div className="modal-buttons">
                      <button
                        className="modal-btn cancel"
                        onClick={() => setShowReactivateConfirm(false)}
                      >
                        Avbryt
                      </button>

                      <button
                        className="modal-btn confirm"
                        onClick={async () => {
                          await handleReactivateSubscription();
                          setShowReactivateConfirm(false);
                        }}
                      >
                        Bekräfta
                      </button>
                    </div>

                  </div>
                </div>
              )}


    </div>
  );
};

export default Subscription;